import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useState } from 'react';
import { Form } from 'semantic-ui-react';
import _compact from 'lodash/compact';
import _includes from 'lodash/includes';
import _values from 'lodash/values';
import _without from 'lodash/without';
import { ItemCartProvider } from './CatalogItemCart.context';
import AddToCartButton from './components/AddToCartButton';
import Description from './components/Description';
import ErrorMessages from './components/ErrorMessages';
import ModifierSetSelection from './components/ModifierSetSelection';
import ModifierSetSelections from './components/ModifierSetSelections';
import PriceSpan from './components/PriceSpan';
import QuantitySelector from './components/QuantitySelector';
import SpecialInstructions from './components/SpecialInstructions';
import Title from './components/Title';
import VariationSelection from './components/VariationSelection';
import { getErrorMessage } from '../../../../utils/api';
import { ChildrenPropType } from '../../../foundation/types/component';
import { MenuCatalogItemPropType, MenuCatalogModifierSetPropType, MenuCatalogModifierPropType, CatalogObjectId } from '../../types/menu-catalog';
import './CatalogItemCart.css';
var defaultProps = {
  modifierLists: [],
  modifiers: [],
  initialSelectedVariation: null,
  initialSelectedModifiers: [],
  initialSpecialInstructions: '',
  initialQuantity: 1
};
function CatalogItemCart(_ref) {
  var item = _ref.item,
    modifierLists = _ref.modifierLists,
    modifiers = _ref.modifiers,
    initialSelectedVariation = _ref.initialSelectedVariation,
    initialSelectedModifiers = _ref.initialSelectedModifiers,
    initialSpecialInstructions = _ref.initialSpecialInstructions,
    initialQuantity = _ref.initialQuantity,
    onAddItem = _ref.onAddItem,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    apiErrorMessage = _useState4[0],
    setApiErrorMessage = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    formErrors = _useState6[0],
    setFormErrors = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = useState(initialSelectedModifiers),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedModifiers = _useState10[0],
    setSelectedModifiers = _useState10[1];
  var _useState11 = useState(initialSelectedVariation),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedVariation = _useState12[0],
    setSelectedVariation = _useState12[1];
  var _useState13 = useState(initialQuantity),
    _useState14 = _slicedToArray(_useState13, 2),
    quantity = _useState14[0],
    setQuantity = _useState14[1];
  var _useState15 = useState(initialSpecialInstructions),
    _useState16 = _slicedToArray(_useState15, 2),
    specialInstructions = _useState16[0],
    setSpecialInstructions = _useState16[1];
  var variations = item.variations;
  function handleFormErrorsChange(key, message) {
    setFormErrors(function (prevFormErrors) {
      return _objectSpread(_objectSpread({}, prevFormErrors), {}, _defineProperty({}, key, message));
    });
  }
  function handleSelectModifier(modifierId) {
    if (_includes(selectedModifiers, modifierId)) {
      setSelectedModifiers(function (prevSelectedModifiers) {
        return _without(prevSelectedModifiers, modifierId);
      });
    } else {
      setSelectedModifiers(function (prevSelectedModifiers) {
        return [].concat(_toConsumableArray(prevSelectedModifiers), [modifierId]);
      });
    }
  }
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var presentFormErrors, newItem;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setTouched(true);
            setApiErrorMessage('');
            presentFormErrors = _compact(_values(formErrors));
            if (!(presentFormErrors.length !== 0)) {
              _context.next = 7;
              break;
            }
            e.preventDefault();
            e.stopPropagation();
            return _context.abrupt("return");
          case 7:
            _context.prev = 7;
            setLoading(true);
            newItem = _objectSpread(_objectSpread({}, item), {
              selectedVariation: {
                _id: selectedVariation
              },
              selectedModifiers: selectedModifiers.map(function (modifierId) {
                return {
                  _id: modifierId
                };
              }),
              quantity: quantity,
              specialInstructions: specialInstructions
            });
            _context.next = 12;
            return onAddItem(newItem);
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](7);
            setApiErrorMessage(getErrorMessage(_context.t0));
          case 17:
            _context.prev = 17;
            setLoading(false);
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 14, 17, 20]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  var context = {
    apiErrorMessage: apiErrorMessage,
    formErrors: formErrors,
    loading: loading,
    touched: touched,
    item: item,
    modifierLists: modifierLists,
    modifiers: modifiers,
    variations: variations,
    selectedModifiers: selectedModifiers,
    selectedVariation: selectedVariation,
    quantity: quantity,
    specialInstructions: specialInstructions,
    setSelectedVariation: setSelectedVariation,
    setQuantity: setQuantity,
    setSpecialInstructions: setSpecialInstructions,
    setFormError: handleFormErrorsChange,
    toggleSelectedModifier: handleSelectModifier
  };
  return /*#__PURE__*/React.createElement(ItemCartProvider, {
    value: context
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    className: "catalog-item-cart"
  }, children));
}
CatalogItemCart.defaultProps = defaultProps;
CatalogItemCart.AddToCartButton = AddToCartButton;
CatalogItemCart.Description = Description;
CatalogItemCart.ErrorMessages = ErrorMessages;
CatalogItemCart.ModifierSetSelection = ModifierSetSelection;
CatalogItemCart.ModifierSetSelections = ModifierSetSelections;
CatalogItemCart.PriceSpan = PriceSpan;
CatalogItemCart.QuantitySelector = QuantitySelector;
CatalogItemCart.SpecialInstructions = SpecialInstructions;
CatalogItemCart.Title = Title;
CatalogItemCart.VariationSelection = VariationSelection;
export default CatalogItemCart;